import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { dashboardAPI } from "../../services";
import "./styles/dashboard.css";

const LowStockAlerts = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fetchedOnce = useRef(false); // avoid double fetch in StrictMode

  useEffect(() => {
    if (fetchedOnce.current) return;
    fetchedOnce.current = true;

    const fetchLowStock = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await dashboardAPI.getLowStockAlerts();
        // Extract low_stock_count from response.data
        const lowStockCount = response?.data?.low_stock_count ?? 0;
        setCount(lowStockCount);
      } catch (err) {
        setError("Could not load low stock data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLowStock();
  }, []);

  return (
    <div className="dashboard-card" style={{ border: "1px solid #FDBA74" }}>
      <h3 className="dashboard-card-title" style={{ marginBottom: "16px" }}>
        Low Stock Alerts
      </h3>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#FFEDD5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#F97316",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
              stroke="none"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
            </svg>
          </div>
          <div>
            <h4
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#EA580C",
                margin: 0,
              }}
            >
              {loading ? "Loading..." : count ?? "--"} Items
            </h4>
            <p style={{ fontSize: "12px", color: "#9A3412", margin: 0 }}>
              {error ? error : "Products below threshold"}
            </p>
          </div>
        </div>

        <button
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            background: "white",
            border: "1px solid #E5E7EB",
            borderRadius: "6px",
            padding: "6px 12px",
            color: "#374151",
            fontSize: "12px",
            fontWeight: "500",
            cursor: "pointer",
          }}
          onClick={() => navigate("/low-stock")}
        >
          View Low Stock
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default LowStockAlerts;
